import { api } from 'src/api';
import { getUserId } from 'src/utils/getUserId';
import { APPLICATION_VERSION } from 'src/error/config/sentry/runTimeConfig';
import type { OAuthProvider } from 'src/components/AuthNew/types';

type EventPayloads = {
  oauth: OAuthProvider;
  google_translate: string;
  oauth_start: OAuthProvider;
  checkout_enter_clicked: string;
  empty_name_or_surname_client: '';
};

type StatsClient = {
  id?: number;
  email?: string;
  phone?: string;
  uuid: string;
};

export async function sendCommonEvents<K extends keyof EventPayloads>(
  eventName: K,
  value: EventPayloads[K],
  clientData?: StatsClient,
): Promise<void> {
  try {
    const statsClientData = clientData ?? { uuid: getUserId() };
    if (!APPLICATION_VERSION)
      throw new Error('No application version provided!');
    const searchType = window.SEARCH_PARAMS && window.SEARCH_PARAMS.search_type;
    await api.postStatsEvent({
      url: window.location.href,
      event: eventName,
      client: statsClientData,
      is_mobile: window.is_mobile,
      release_version: APPLICATION_VERSION,
      search_type: searchType,
      value,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}
